module.exports = "/packs/jcb-8f14ca43c2bdaffbe281c8753ef6e168.png";